
import { mapActions, mapState, mapMutations } from "vuex";
import OrderDetailsSimple from "./order-details-simple.vue";
import orderItemsList from "./order-items-list.vue";
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
import EmergencyLoader from "../common/emergency-loader.vue";

export default {
  components: {
    orderItemsList,
    OrderDetailsSimple,
    ResponsiveDialog,
    EmergencyLoader
  },
  data() {
    return {
      showCancelOrderList: false,
      panel: null,
      // cancelledOrders: [],
      cancelledOrderDetail: {},
      cancelledOrderDetailLoading: false,
      loading: false
    };
  },
  props: {
    showCancelOrderAlert: true
  },
  watch: {
    panel(val) {
      if (val != null) {
        this.getCancelledOrderDetail();
      }
    },
    showCancelOrderList(isVisible) {
      if (isVisible) {
        this.getCancelledOrderDetail();
      }
    }
  },
  computed: {
    ...mapState("reciever", ["cancelledOrders"])
  },
  mounted() {
    this.panel = 0;
  },
  methods: {
    ...mapActions("reciever", ["getOrderDetailsObj", "cancelOrderAcknowledge"]),
    ...mapMutations("reciever", ["REMOVE_CANCELLED_ORDER"]),

    async handleOk() {
      this.loading = true;
      this.$nuxt.$emit("stop-audio-alert");
      await this.handleCancelOrderAcknowledge();
      this.REMOVE_CANCELLED_ORDER(this.panel);
      this.panel = null;
      setTimeout(() => {
        this.panel = 0;
      }, 100);
      this.panel = 0;
      this.loading = false;
    },
    handleCloseAlert() {
      this.$nuxt.$emit("stop-audio-alert");
      this.REMOVE_CANCELLED_ORDER("all");
      this.showCancelOrderAlert = false;
    },
    handleAlertClick() {
      this.$nuxt.$emit("stop-audio-alert");
      this.showCancelOrderList = !this.showCancelOrderList;
    },
    async handleCancelOrderAcknowledge() {
      try {
        await this.cancelOrderAcknowledge({
          orderId: this.cancelledOrders[this.panel].id
        });
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    },
    getCancelledOrderDetail() {
      if (this.cancelledOrders && this.cancelledOrders.length > 0) {
        this.cancelledOrderDetailLoading = true;
        var $this = this;
        this.getOrderDetailsObj({
          orderId: this.cancelledOrders[0].id
        })
          .then((response) => {
            $this.cancelledOrderDetail = response;
          })
          .catch((errr) => {})
          .finally(() => {
            $this.cancelledOrderDetailLoading = false;
          });
      }
    }
  }
};
